
export const dollarNumber = (amount) => {
    const strAmount = amount.toString();
    const position = strAmount.indexOf('.');
    return addComma(position < 0 ? strAmount: strAmount.substring(0,position));
}

function addComma(num: string) {
    const reg = num.indexOf('.') > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(\d{3})+$)/g;
    return num.replace(reg, '$1,');
}

export const centNumber = (amount) => {
    const strAmount = Number.parseFloat(amount).toFixed(2);
    const position = strAmount.indexOf('.');
    return strAmount.substring(position);
}

export const getFormatNumber = (amount: number) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
}
